export default "__VITE_ASSET__BxyaVuS7__"